import { type RingProgressFactory, RingProgress as MantineRingProgress } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import type { IProps } from "./progress-circle.types";

/**
 * Circular progress ring for displaying a percentage value visually, with an optional center label.
 * The track defaults to the subtle gray design token so consumers do not need to pass colour
 * tokens themselves.
 * @param props - Mantine RingProgress props.
 * @returns The ProgressCircle component.
 */
const ProgressCircle = componentWrapper<RingProgressFactory, IProps>(
    "ProgressCircle",
    ({ rootColor = "var(--surface-gray-transparent-color)", ...props }, ref) => {
        return <MantineRingProgress ref={ref} rootColor={rootColor} {...props} />;
    }
);

export { ProgressCircle };
